import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import toggleClass from 'utils/DOM/toggleClass'
import isArray from 'utils/validation/isArray'
import getById from 'utils/DOM/getById'
import innerHTML from 'utils/DOM/innerHTML'
import { CDN_PIVOT } from 'core/constants/endpoints'
import {
  ECONOMY,
  DELUXE,
  STANDARD,
  CHOICE,
  ECONOMY_NAME,
  DELUXE_NAME,
  STANDARD_NAME,
  CHOICE_NAME
} from 'core/constants/products'

const planTypesToShow = [
  {
    id: ECONOMY,
    name: ECONOMY_NAME
  },
  {
    id: DELUXE,
    name: DELUXE_NAME
  },
  {
    id: STANDARD,
    name: STANDARD_NAME
  },
  {
    id: CHOICE,
    name: CHOICE_NAME
  }
]

const templateShopping = Templater(getById('template-shopping').innerText)

// cspell:disable
const extraDataToShopping = [
  {
    img: `${CDN_PIVOT}/sem/cro/img/ilustration-landing-page/plans-monthly.png`,
    type: 'lowest monthly payments'
  },
  {
    img: `${CDN_PIVOT}/sem/cro/img/ilustration-landing-page/plans-anual.png`,
    type: 'college students'
  },
  {
    img: `${CDN_PIVOT}/sem/cro/img/ilustration-landing-page/plans-singles.png`,
    type: 'lowest deductible'
  },
  {
    img: `${CDN_PIVOT}/sem/cro/img/ilustration-landing-page/plans-families.png`,
    type: 'doctor office copays'
  },
  {
    img: `${CDN_PIVOT}/sem/cro/img/ilustration-landing-page/freedom-doctor.png`,
    type: 'rx drug coverage'
  },
  {
    img: `${CDN_PIVOT}/sem/cro/img/ilustration-landing-page/lowest-price.png`,
    type: '1,000,000 coverage'
  }
]
// cspell:enable

function renderShoppingModule(response, hcStorage) {
  if (
    response &&
    !response.error &&
    isArray(response.data.shoppingModule) &&
    response.data.shoppingModule.length > 0
  ) {
    const typesData = response.data.type
    planTypesToShow.forEach(({ id, name }) => {
      const data = typesData[id]
      if (data) {
        innerHTML(`#${name}-min`, Math.round(data.min))
        innerHTML(`#${name}-max`, Math.round(data.max))
      }
    })
    innerHTML('#location', `${hcStorage.location.state}`)

    innerHTML(
      '#shopping-list',
      response.data.shoppingModule
        .map((item, index) => {
          return templateShopping(Object.assign(item, extraDataToShopping[index]))
        })
        .join('')
    )

    toggleClass(document.body, 'loading', false)
  }
}

export default renderShoppingModule
